import React, { Component } from "react";
import Link from "gatsby-link";
import cx from "classnames";
import { bounce } from "react-animations";
import { StyleSheet, css } from "aphrodite";

const rota1 = {
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(45deg)"
  }
};
const rota1inv = {
  to: {
    transform: "rotate(0deg)"
  },
  from: {
    transform: "rotate(45deg)"
  }
};
const rota3 = {
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(-45deg)"
  }
};
const rota3inv = {
  to: {
    transform: "rotate(0deg)"
  },
  from: {
    transform: "rotate(-45deg)"
  }
};
const fade = {
  from: {
    strokeOpacity: 1
  },
  to: {
    strokeOpacity: 0
  }
};
const fadeinv = {
  from: {
    strokeOpacity: 0
  },
  to: {
    strokeOpacity: 1
  }
};

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      used: false
    };
  }

  toggle() {
    this.setState({
      open: !this.state.open,
      used: true
    });
  }

  render() {
    const { links } = this.props;
    const styles = StyleSheet.create({
      rota1: {
        animationName: rota1,
        transform: "rotate(45deg)",
        animationDuration: "0.5s"
      },
      rota1inv: {
        animationName: rota1inv,
        animationDuration: "0.5s",
        transform: "rotate(0deg)"
      },
      rota3: {
        animationName: rota3,
        transform: "rotate(-45deg)",
        animationDuration: "0.5s"
      },
      rota3inv: {
        animationName: rota3inv,
        animationDuration: "0.5s",
        transform: "rotate(0deg)"
      },
      fade: {
        animationName: fade,
        animationDuration: "0.5s",
        strokeOpacity: 0
      },
      fadeinv: {
        animationName: fadeinv,
        animationDuration: "0.5s",
        strokeOpacity: 1
      }
    });

    return (
      <div className="c-hamburger">
        <div
          className={cx("c-hamburger--icon")}
          onClick={this.toggle.bind(this)}
        >
          <svg
            width="40px"
            height="40px"
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <line
              x1="5"
              y1="10"
              x2="45"
              y2="10"
              strokeWidth="4"
              strokeLinecap="round"
              stroke="black"
              className={
                this.state.used &&
                (this.state.open ? css(styles.rota1) : css(styles.rota1inv))
              }
            />
            <line
              x1="5"
              y1="25"
              x2="45"
              y2="25"
              className={
                this.state.used &&
                (this.state.open ? css(styles.fade) : css(styles.fadeinv))
              }
              strokeWidth="4"
              strokeLinecap="round"
              stroke="black"
            />
            <line
              x1="5"
              y1="40"
              x2="45"
              y2="40"
              className={
                this.state.used &&
                (this.state.open ? css(styles.rota3) : css(styles.rota3inv))
              }
              strokeWidth="4"
              strokeLinecap="round"
              stroke="black"
            />
          </svg>
        </div>
        {this.state.open && (
          <div className="c-hamburger--block">
            {links.map((link, idx) => (
              <Link to={link.to}>
                <div
                  key={idx}
                  className="c-hamburger--item"
                  onClick={this.toggle.bind(this)}
                >
                  {link.text}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/molecules/Hamburger.js